import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { TypeCredit } from "../../core/model/type-credit";
import { Workflow } from "../../core/model/workflow";
import { WorkflowService } from "../../core/service/workflow.service";
import { TypeCreditService } from "../../core/service/type-credit.service";

@Component({
  selector: "app-edit-type-credit",
  templateUrl: "./edit-type-credit.component.html",
  styleUrls: ["./edit-type-credit.component.scss"],
})
export class EditTypeCreditComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  typeCreditId: number;
  typeCredit: TypeCredit;
  workflows: Workflow[];

  constructor(
    private _router: Router,
    private _workflowService: WorkflowService,
    private _activatedRoute: ActivatedRoute,
    private _typeCreditService: TypeCreditService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      workflow: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.typeCreditId = params["typeCreditId"];
      this.getTypeCredit(this.typeCreditId);
      this.getWorkflows();
    });
  }

  getTypeCredit(typeCreditId) {
    this.loading = true;
    this._typeCreditService.getTypeCreditById(typeCreditId).subscribe(
      (data) => {
        this.typeCredit = {
          ...data,
          workflow: data.workflow ? { ...data.workflow } : new Workflow(),
        };
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  getWorkflows() {
    this._workflowService.getAllWorkflows().subscribe(
      (data) => {
        this.workflows = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    const selected = (this.workflows || []).find(
      (w) => w.id === this.typeCredit.workflow.id
    );
    if (selected) {
      this.typeCredit.workflow = { ...selected };
    }
    this.pressButton = true;
    this._typeCreditService
      .update(this.typeCredit)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/type-credit");
  }
}
